
import React from 'react';
import {tabImages} from './common';
import $ from 'jquery';
require('./Grid.css');

let GRID_WIDTH = 800;
let CELL_SIZE = GRID_WIDTH / 4;
let DETAIL_WIDTH = GRID_WIDTH-5*2;
let DETAIL_MARGIN_SIDE = 10;
let DETAIL_MARGIN_TOP = 150;
let DETAIL_MARGIN_BOTTOM = 10;
let ARROW_SIZE = 30;
let DETAIL_TITLE_OFFSET = 30;
let DETAIL_IMAGE_WIDTH = DETAIL_WIDTH-DETAIL_MARGIN_SIDE*2;

class Grid extends React.Component {
  constructor(props) {
    super(props);

    //loading images
    this.state = this.load(props.images, props.width);
  }

  load(images, width) {
    const isMobile = width < 800;

    this.media = isMobile ? 'mobile' : 'desktop';
    this.cellCountInRow = isMobile ? 2 : 4;

    GRID_WIDTH = isMobile ? width : 800;
    CELL_SIZE = GRID_WIDTH / this.cellCountInRow;
    DETAIL_WIDTH = GRID_WIDTH-5*2;
    DETAIL_MARGIN_SIDE = 10;
    DETAIL_MARGIN_TOP = 160;
    DETAIL_MARGIN_BOTTOM = 10;
    ARROW_SIZE = 30;
    DETAIL_TITLE_OFFSET = 30;
    DETAIL_IMAGE_WIDTH = DETAIL_WIDTH-DETAIL_MARGIN_SIDE*2;

    let numOfLoadedImages = 0;
    images.forEach( desc => {
      if (desc[ this.media + '-height'] &&
          desc[ this.media + '-width']) {
        numOfLoadedImages ++;
      }
      else {
        const bigImg = new Image();
        bigImg.onload = () =>{
          if (bigImg.width + bigImg.height == 0) {
            bigImg.onerror();
            return;
          }
          desc[ this.media + '-height'] = bigImg.height;
          desc[ this.media + '-width'] = bigImg.width;
          numOfLoadedImages ++;
          this.setState({ numOfLoadedImages: numOfLoadedImages });
        };
        bigImg.onerror = () =>{
          desc[ this.media + '-height'] = 256;
          desc[ this.media + '-width'] = 256;
          desc[ this.media + '-image'] = desc['thumbnail-image'];
          numOfLoadedImages ++;
          this.setState({ numOfLoadedImages: numOfLoadedImages });
        };
        bigImg.src = 'images/' + desc[ this.media + '-image'];
      }
    });

    return {
      current: null,
      numOfLoadedImages: numOfLoadedImages
    };
  }

  componentWillReceiveProps(props) {
    if(props.width !== this.props.width) {
      this.setState(
        this.load(props.images, props.width)
      );
    }
  }

  getRowIndex(imageIndex) {
    return imageIndex === null ? null : Math.floor(imageIndex / this.cellCountInRow);
  }

  getDetailImageHeight(imageIndex) {
    const desc = this.props.images[imageIndex];
    return desc[ this.media + '-height'] * DETAIL_IMAGE_WIDTH
      / desc[ this.media + '-width'];
  }

  getDetailHeight(imageIndex) {
    return ARROW_SIZE + DETAIL_MARGIN_TOP
      + this.getDetailImageHeight(imageIndex) + DETAIL_MARGIN_BOTTOM;
  }

  getCellStyle(imageIndex) {
    let style = 'cell';
    if (this.state.current !== null) {
      style += this.state.current === imageIndex ? ' cell-active' : ' cell-inactive';
    }
    return style;
  }

  getDetailSVGPath(ord, height) {
    const E = ARROW_SIZE;
    const W = DETAIL_WIDTH;
    const U = W / this.cellCountInRow;
    const P = U*ord + U/2;
    return `
      M0.5 ${E} 
      L${P-E} ${E}
      L${P} 0
      L${P+E} ${E}
      L${W-0.5} ${E}
      L${W-0.5} ${height-0.5}
      L0.5 ${height-0.5} Z`;
  }

  activate(i) {
    if (this.state.current === i) {
      if (this.state.current !== null) {
        this.setState({ current: null });
        this.props.onTypeChange ( null );

        setTimeout( () => {
          const e = $(`[data-index=${i}]`);
          $('html, body').animate({
            scrollTop: e.offset().top - 50
          }, 500);
        }, 310);
      }
    } else {
      this.setState({ current: i });
      this.props.onTypeChange ( this.props.images[i].type );

      setTimeout( () => {
        const e = $(`[data-index=${i}]`);
        $('html, body').animate({
          scrollTop: e.offset().top - 50
        }, 500);
      }, 310);
    }
  }

  render() {

    const images = this.props.images;
    const numOfImages = images.length;

    if (this.state.numOfLoadedImages < numOfImages) {
      return <div className="loader">
        {this.state.numOfLoadedImages} / {this.props.images.length}
      </div>
    }
    const rows = [];
    const cols = this.cellCountInRow;
    const numOfRows = Math.ceil(numOfImages / cols);
    for (let y = 0; y < numOfRows; y++) {
      const row = [];

      for (let i = y * cols; i < Math.min((y+1) * cols, numOfImages); i++) {
        row.push(i);
      }
      rows.push(row);
    }



    return <
      div className = 'grid'
          style = {{ width: GRID_WIDTH + 'px'}}
    >
      {rows.map( (row, y) => <div key = {y}>
        <div className = 'row'>
          {row.map( (i,x) => <div
            key = {x}
            className = {this.getCellStyle(i)}
            data-index = {i}
            onClick={ () => {
              this.activate(i);
            }}
            style = {{
              width: CELL_SIZE,
              height: CELL_SIZE
            }}
          >
            <div
              className = 'cell-image'
              style={{
                backgroundImage: `url(${'images/' + images[i]['thumbnail-image']})`
              }}
            >
            </div>

            <div className = 'cell-title' >
              <img src = {tabImages[images[i].type].white} />
              {images[i].title}
            </div>

          </div>)
          }
        </div>
        <div className = 'detail'>
          {row.map( (i,x) => <div
            key = {x}

            className = {this.state.current === i ? 'detail-visible' : 'detail-hidden'}
            style = {{
              height: this.state.current === i ? this.getDetailHeight(i) : 0
            }}
            onClick={ this.state.current === i ? () => this.activate(i) : () => {} }
          >

            <svg
              className={ images[i].background ? 'shape-black' : 'shape-white' }
              height={this.getDetailHeight(i)}
              width={DETAIL_WIDTH}
            >
              <path d={this.getDetailSVGPath(x, this.getDetailHeight(i))} />
              <image
                x={DETAIL_TITLE_OFFSET} y={ARROW_SIZE + DETAIL_TITLE_OFFSET}
                height={30}
                width={30}
                xlinkHref={tabImages[images[i].type].white}
              />
              <text
                x={DETAIL_TITLE_OFFSET}
                y={ARROW_SIZE + DETAIL_TITLE_OFFSET + 60}
                className="shape-text"
              >
                {images[i].title}
              </text>

              <text
                x={DETAIL_TITLE_OFFSET}
                y={ARROW_SIZE + DETAIL_TITLE_OFFSET + 80}
                className="shape-text-2"
              >
                {images[i].subtitle}
              </text>

              <image
                x={DETAIL_MARGIN_SIDE} y={ARROW_SIZE + DETAIL_MARGIN_TOP}
                height={this.getDetailImageHeight(i)}
                width={DETAIL_IMAGE_WIDTH}
                xlinkHref={'images/' + images[i][this.media + '-image']}
              />
            </svg>

          </div>)}
        </div>
      </div>)}
    </div>
    ;
  }
}

export default Grid;





// WEBPACK FOOTER //
// ./src/components/Grid.js